"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const mapStateToProps = state => {
  return {
    auth: state.auth
  };
};
const MaintenanceMode = props => {
  const {
    auth
  } = props;
  const obj = JSON.parse(auth.data);
  const begin = new Date(obj.begin);
  const end = new Date(obj.end);
  const dateOptions = {
    timeZone: "CET",
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric"
  };
  const dateFormatter = new Intl.DateTimeFormat("en-US", dateOptions);
  const dateAsFormattedStringBegin = dateFormatter.format(new Date(begin));
  const dateAsFormattedStringEnd = dateFormatter.format(new Date(end));
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      flexFlow: "column",
      height: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container-fluid justify-content-center mt-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex mb-4 align-items-center"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "page-title ml-0 mr-5"
  }, "Maintenance Mode")), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-inline-flex justify-content-start card card-wide rounded shadow mb-3 p-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col",
    style: {
      marginBottom: "30px"
    }
  }, /*#__PURE__*/_react.default.createElement("h4", null, "We'll be back soon")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col",
    style: {
      marginBottom: "30px"
    }
  }, /*#__PURE__*/_react.default.createElement("p", null, "We're just tuning up a few things and are running a Maintenance Period.")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Maintenance mode started:")), /*#__PURE__*/_react.default.createElement("p", null, dateAsFormattedStringBegin), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Maintenance mode will end:")), /*#__PURE__*/_react.default.createElement("p", null, dateAsFormattedStringEnd)))), /*#__PURE__*/_react.default.createElement(_components.ImprintLink, null));
};
MaintenanceMode.propTypes = process.env.NODE_ENV !== "production" ? {
  auth: _propTypes.default.object
} : {};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(MaintenanceMode);
module.exports = exports.default;